var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.292,
    height: 17.292,
    viewBox: "0 0 17.292 17.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.76,11.178a8.613,8.613,0,0,0-3.286-2.061,5,5,0,1,0-5.656,0A8.66,8.66,0,0,0,0,17.292H1.351a7.3,7.3,0,0,1,14.59,0h1.351A8.59,8.59,0,0,0,14.76,11.178ZM8.646,8.646A3.648,3.648,0,1,1,12.294,5,3.652,3.652,0,0,1,8.646,8.646Z",
    transform: "translate(0)",
    fill: "#8a8a8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ecbdb942cdf55fc921c2a42e69fcdee8.svg";
export { ForwardRef as ReactComponent };